import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import classNames from 'classnames';
import { formatDateTime } from '@utils/timeUtils'; // 相对路径
import { formatNumberToWan } from '@utils/formatNumber';
import InfiniteScrollList from '@components/InfiniteScrollList';
import { highlightname } from '@utils/high-light-name';

interface PCWaterfallFlowProps extends RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    data: any;
    type?:   any;   // 类型 1：正常作品列表 2：我的作品
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式
    isLeftSize?: any
    searchKeyword?: any
}

@inject('app', 'site',)
@observer
class PCWaterfallFlow extends React.Component<PCWaterfallFlowProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    // 瀑布流布局 - 将数据分配到两列
    distributeToColumns = (data: any[]) => {
        const columns: any[][] = [[], []];
        
        data.forEach((item, index) => {
            const columnIndex = index % 2;
            columns[columnIndex].push(item);
        });
        
        return columns;
    }
    
// 渲染瀑布流项 - 根据提供的数据结构
    renderWaterfallItem = (item: any, index: number) => {
        let { searchKeyword, type } = this.props;
        
        return (
            <div key={item.id || index} className={styles.waterfallItem}>
                <div className={styles.waterfallCard}>
                    {item.image && (
                        <div className={styles.waterfallImgBox}>
                            <img 
                                src={item.image} 
                                alt={item.name}
                                className={styles.waterfallImg}
                                onError={(e) => {
                                    e.currentTarget.src = `${BASE_IMG_URL}/common/null.png`;
                                }}
                            />
                            {/* status 为0 待审核，1 审核通过，2 审核未通过，3 下架  */}
                            {item.status == 1 && <div className={styles.waterfallVoteCount}>{item.voteCount}票</div>}
                            {item.status == 0 && <div className={classNames(styles.waterfallStatus)}>
                                <img 
                                    src={`${BASE_IMG_URL}/photography/icon1.png`} 
                                    alt="审核中"
                                    className={styles.icon}
                                />审核中
                            </div>}
                            {item.status == 2 && <div className={classNames(styles.waterfallStatus, styles.waterfallStatus2)}>
                                <img 
                                    src={`${BASE_IMG_URL}/photography/icon2.png`} 
                                    alt="审核中"
                                    className={styles.icon}
                                />
                                审核未通过
                            </div>}
                            {item.status == 3 && <div className={classNames(styles.waterfallStatus, styles.waterfallStatus2)}>
                                已下架
                                <img 
                                    src={`${BASE_IMG_URL}/photography/icon2.png`} 
                                    alt="审核中"
                                    className={styles.icon}
                                />
                            </div>}
                            
                        </div>
                    )}
                    
                    <div className={styles.waterfallInfo}>
                        <div className={styles.numBox}>
                            {type == 2 && <div className={styles.waterfallRanking}>{item.ranking}</div>}
                            <div className={styles.waterfallNumber}>{item.number}</div>
                        </div>
                        
                        <div className={styles.waterfallName} 
                            dangerouslySetInnerHTML={{
                                __html: searchKeyword 
                                    ? highlightname(item.name, searchKeyword) 
                                    : item.name
                            }}
                        />
                        <div className={styles.waterfallUserInfo}>
                            <div className={styles.userInfo}>
                                {item.user?.avatar && (
                                    <img 
                                        src={item.user.avatar} 
                                        alt={item.user.nickname}
                                        className={styles.userAvatar}
                                        onError={(e) => {
                                            e.currentTarget.src = `${BASE_IMG_URL}/common/avatar.png`;
                                        }}
                                    />
                                )}
                                <span className={styles.userName}>{item.user?.nickname}</span>
                            </div>
                            <div className={classNames(styles.voteBtn, item.isVoted ? styles.votedBtn : '')}>{item.isVoted ? '已投' : '投票'}</div>
                        </div>
                        

                        {/* <div className={styles.stats}>
                            <div className={styles.voteCount}>
                                {formatNumberToWan(item.voteCount)}票
                            </div>
                            <div className={styles.progress}>
                                进度: {item.progress}%
                            </div>
                        </div> */}

                        {/* {item.rejectReason && (
                            <div className={styles.rejectReason}>
                                拒绝原因: {item.rejectReason}
                            </div>
                        )} */}

                        {/* <div className={styles.timeInfo}>
                            <div>创建: {formatDateTime(item.createdAt)}</div>
                            <div>更新: {formatDateTime(item.updatedAt)}</div>
                        </div> */}
                    </div>
                </div>
            </div>
        );
    }

    renderContent() {
        const { data, loading = false, hasMore = true, emptyText, emptyIcon, emptyBoxStyle, onLoadMore } = this.props;
        if (!Array.isArray(data)) return null;
        
        // 如果是空数据，显示空状态
        if (data.length === 0) {
            return (
                <InfiniteScrollList
                    variant="h5"
                    data={[]}
                    loading={loading}
                    hasMore={hasMore}
                    onLoadMore={onLoadMore || (() => { })}
                    renderItem={() => null}
                    emptyText={emptyText || '暂无数据'}
                    emptyIcon={emptyIcon || `${BASE_IMG_URL}/common/null.png`}
                    emptyBoxStyle={emptyBoxStyle}
                />
            );
        }
        
        return (
            <div className={styles.waterfallContainer}>
                <div className={styles.waterfallColumns}>
                    {data.map((item, index) => this.renderWaterfallItem(item, index))}
                </div>
                
                {/* 加载更多 */}
                {hasMore && (
                    <div className={styles.loadMoreContainer}>
                        {loading ? (
                            <div className={styles.loadingText}>加载中...</div>
                        ) : (
                            <button 
                                className={styles.loadLoadMoreButton}
                                onClick={onLoadMore}
                            >
                                加载更多
                            </button>
                        )}
                    </div>
                )}
                
                {!hasMore && data.length > 0 && (
                    <div className={styles.noMoreText}>没有更多数据了</div>
                )}
            </div>
        );
    }

    render() {
        return this.renderContent();
    }
}

export default withRouter(PCWaterfallFlow);